import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { gql } from 'graphql-tag';
import { wrapQuery } from "../../utils/wrapQuery";
import { getClientId } from "../../utils/config";
export { authenticateMfa };
var authenticateMfaQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  mutation AuthenticateMfa($params: MFAByAppParams!, $clientId: String!, $deviceId: String) {\n    authenticateMFA(mfaByAppParams: $params, clientId: $clientId, deviceId: $deviceId) {\n      tokens {\n        idToken\n        accessToken\n        expires\n      }\n    }\n  }\n"])));
async function authenticateMfa(params, deviceId) {
  var data = await wrapQuery('authenticateMfa', authenticateMfaQuery, {
    params: params,
    clientId: getClientId(),
    deviceId: deviceId
  });
  return data.authenticateMFA.tokens;
}